import { Container, Flex, Text, Title } from "@mantine/core";
import { useEffect, useEffectEvent } from "react";

import { getRootDispatcher } from "@/analytics";
import { useLogger } from "@/sdk";

import { BrokenComputerIcon } from "../Icons";

export function EnrollFailureScreen({ isProductAsurionBilled }: { isProductAsurionBilled?: boolean }) {
    const logger = useLogger({ module: "EnrollFailure", supportTeam: "sales" });

    const onShowEnrollmentFailure = useEffectEvent(() => {
        logger.warn("hit a snag during enrollment");
        void getRootDispatcher().dispatchBusinessEvent("EnrollmentSnagDisplayed");
    });

    useEffect(() => {
        onShowEnrollmentFailure();
    }, []);
    return (
        <Flex p="xl" ta="center" direction="column" justify="center" data-testid="sale-finished-view">
            <Container>
                <BrokenComputerIcon />
            </Container>
            <Title
                mt="xxl"
                c="dark.0"
                size="h5"
                fw="var(--mantine-font-weight-heavy)"
                data-testid="sale-view-status-header"
            >
                Hmmm...something went wrong
            </Title>
            <Text c="dark.0" mt="md" size="sm">
                {isProductAsurionBilled
                    ? "We weren’t able to enroll the customer today, but they may be able to try again in the future."
                    : "Don’t worry—we’ll keep trying but there’s a chance it won’t go through."}
            </Text>
        </Flex>
    );
}
